import { Badge, DataTable, Select, stamp, useTable } from "./ui";

export default function MessagesPage() {
  const table = useTable("/admin/tables/notifications");
  const columns = [
    { key: "created_at", label: "Sent", sortable: true, render: (r) => <span className="text-xs whitespace-nowrap">{stamp(r.created_at)}</span> },
    { key: "channel", label: "Channel", sortable: true, render: (r) => <Badge tone={r.success ? "good" : "bad"}>{r.channel}</Badge> },
    { key: "kind", label: "Message", sortable: true },
    { key: "to", label: "To", render: (r) => <span className="text-xs break-all">{r.to}</span> },
    { key: "success", label: "Delivered", render: (r) => <Badge tone={r.success ? "good" : "warn"}>{r.success ? "yes" : "no"}</Badge> },
    { key: "detail", label: "Detail", render: (r) => <span className="text-xs text-muted">{(r.detail || "").slice(0, 90)}</span> },
  ];
  return (
    <DataTable table={table} columns={columns} testid="messages-table" name="messages"
               searchPlaceholder="Recipient, kind, detail…" empty="Nothing sent yet."
               filters={(
                 <>
                   <Select testid="messages-filter-channel" placeholder="Any channel" value={table.params.channel} onChange={(v) => table.set({ channel: v })}
                           options={["email", "sms", "whatsapp"]} />
                   <Select testid="messages-filter-success" placeholder="Delivered or not" value={table.params.success} onChange={(v) => table.set({ success: v })}
                           options={[{ value: "yes", label: "Delivered" }, { value: "no", label: "Failed" }]} />
                 </>
               )} />
  );
}
